<template>
  <el-button-group class='btn-group'>
    <slot></slot>
  </el-button-group>
</template>

<script>
  export default {
  }
</script>

<style scoped>
  .btn-group {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/cx/cxBtnGroup.vue